import { c as _c } from "react/compiler-runtime";
import { COUNTRIES } from '@onefootprint/core';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TemplatedText from '../../../components/templated-text';
import type { CustomQuestionsFormData } from '../../../types';
import { previewLabel } from '../../../utils/preview-label';
type ShortTextPreviewProps = {
  questionIndex: number;
};
const ShortTextPreview = t0 => {
  const $ = _c(79);
  const {
    questionIndex
  } = t0;
  const {
    t
  } = useTranslation("playbook-custom-questions");
  const {
    control
  } = useFormContext();
  const t1 = `questions.${questionIndex}.label`;
  const t2 = `questions.${questionIndex}.required`;
  const t3 = `questions.${questionIndex}.format`;
  const t4 = `questions.${questionIndex}.placeholder`;
  const t5 = `questions.${questionIndex}.supportedCountries`;
  let t6;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
    t6 = [t1, t2, t3, t4, t5];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = t6 as never;
  let t8;
  if ($[6] !== control || $[7] !== t7) {
    t8 = {
      control,
      name: t7
    };
    $[6] = control;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const [label, required, format, placeholder, supportedCountries] = useWatch(t8) as [string, boolean, string, string, string[] | undefined];
  let t9;
  if ($[9] !== supportedCountries) {
    t9 = supportedCountries && supportedCountries.length > 0 ? COUNTRIES.filter(c => supportedCountries.includes(c.value)).map(_temp) : undefined;
    $[9] = supportedCountries;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const countryOptions = t9;
  let t10;
  if ($[11] !== t) {
    t10 = trimmed => t(_temp2, {
      label: trimmed
    });
    $[11] = t;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== label || $[14] !== required || $[15] !== t10) {
    t11 = previewLabel(label, required, t10);
    $[13] = label;
    $[14] = required;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const labelWithOptional = t11;
  let t12;
  if ($[17] !== labelWithOptional) {
    t12 = labelWithOptional && <TemplatedText value={labelWithOptional} />;
    $[17] = labelWithOptional;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const labelNode = t12;
  let t13;
  if ($[19] !== format || $[20] !== labelNode || $[21] !== questionIndex) {
    t13 = format === "ssn9" && <Form.Ssn9 name={`questions.${questionIndex}.preview`} label={labelNode} />;
    $[19] = format;
    $[20] = labelNode;
    $[21] = questionIndex;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== format || $[24] !== labelNode || $[25] !== placeholder || $[26] !== questionIndex || $[27] !== t) {
    t14 = format === "zip" && <Form.Zip name={`questions.${questionIndex}.preview`} label={labelNode} placeholder={placeholder || t(_temp3)} />;
    $[23] = format;
    $[24] = labelNode;
    $[25] = placeholder;
    $[26] = questionIndex;
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== format || $[30] !== labelNode || $[31] !== placeholder || $[32] !== questionIndex || $[33] !== t) {
    t15 = format === "email" && <Form.Email name={`questions.${questionIndex}.preview`} label={labelNode} placeholder={placeholder || t(_temp4)} />;
    $[29] = format;
    $[30] = labelNode;
    $[31] = placeholder;
    $[32] = questionIndex;
    $[33] = t;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== format || $[36] !== labelNode || $[37] !== questionIndex) {
    t16 = format === "us_tax_id" && <Form.UsTaxId name={`questions.${questionIndex}.preview`} label={labelNode} />;
    $[35] = format;
    $[36] = labelNode;
    $[37] = questionIndex;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== format || $[40] !== labelNode || $[41] !== questionIndex) {
    t17 = format === "phone_number" && <Form.Tel name={`questions.${questionIndex}.preview`} label={labelNode} />;
    $[39] = format;
    $[40] = labelNode;
    $[41] = questionIndex;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== format || $[44] !== labelNode || $[45] !== questionIndex) {
    t18 = format === "date" && <Form.Date name={`questions.${questionIndex}.preview`} label={labelNode} />;
    $[43] = format;
    $[44] = labelNode;
    $[45] = questionIndex;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== format || $[48] !== labelNode || $[49] !== questionIndex) {
    t19 = format === "dob" && <Form.Date name={`questions.${questionIndex}.preview`} label={labelNode} />;
    $[47] = format;
    $[48] = labelNode;
    $[49] = questionIndex;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== format || $[52] !== labelNode || $[53] !== placeholder || $[54] !== questionIndex || $[55] !== t) {
    t20 = format === "vehicle_identification_number" && <Form.Vin name={`questions.${questionIndex}.preview`} label={labelNode} placeholder={placeholder || t(_temp5)} />;
    $[51] = format;
    $[52] = labelNode;
    $[53] = placeholder;
    $[54] = questionIndex;
    $[55] = t;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] !== countryOptions || $[58] !== format || $[59] !== labelNode || $[60] !== questionIndex) {
    t21 = format === "country" && <Form.Country name={`questions.${questionIndex}.preview` as never} label={labelNode} options={countryOptions} />;
    $[57] = countryOptions;
    $[58] = format;
    $[59] = labelNode;
    $[60] = questionIndex;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  let t22;
  if ($[62] !== format || $[63] !== labelNode || $[64] !== placeholder || $[65] !== questionIndex || $[66] !== t) {
    t22 = (format === "any" || !format) && <Form.Input name={`questions.${questionIndex}.preview`} label={labelNode} placeholder={placeholder || t(_temp6)} />;
    $[62] = format;
    $[63] = labelNode;
    $[64] = placeholder;
    $[65] = questionIndex;
    $[66] = t;
    $[67] = t22;
  } else {
    t22 = $[67];
  }
  let t23;
  if ($[68] !== t13 || $[69] !== t14 || $[70] !== t15 || $[71] !== t16 || $[72] !== t17 || $[73] !== t18 || $[74] !== t19 || $[75] !== t20 || $[76] !== t21 || $[77] !== t22) {
    t23 = <>{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}</>;
    $[68] = t13;
    $[69] = t14;
    $[70] = t15;
    $[71] = t16;
    $[72] = t17;
    $[73] = t18;
    $[74] = t19;
    $[75] = t20;
    $[76] = t21;
    $[77] = t22;
    $[78] = t23;
  } else {
    t23 = $[78];
  }
  return t23;
};
export default ShortTextPreview;
function _temp(c_0) {
  return {
    value: c_0.value as Iso3166TwoDigitCountryCode,
    label: c_0.label
  };
}
function _temp2($) {
  return $.preview.labelOptional;
}
function _temp3($_0) {
  return $_0.preview.zipPlaceholder;
}
function _temp4($_1) {
  return $_1.preview.emailPlaceholder;
}
function _temp5($_2) {
  return $_2.preview.vinPlaceholder;
}
function _temp6($_3) {
  return $_3.preview.yourAnswer;
}